// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ZuOR","productName":"Table_productName__E6AzA"};